import { type UsersState } from "./state";

export const initialState: UsersState = {
  users: [],
  roles: [],
  zones: [],
  isPending: false,
  isRejected: false,
  errorMessage: "",
  isSaving: false,
  saveError: "",
};
